import React, { useState } from "react";
import DashboardView from "./DashboardView";

function OperationDashboard() {
  const [currentView, setCurrentView] = useState("dashboard");

  return (
    <div className="flex-1 flex flex-col">
      <main className="flex-1 p-2 md:p-2">
        {currentView === "dashboard" && (
          <DashboardView
            setCurrentView={setCurrentView}
          />
        )}
      </main>
    </div>
  );
}

export default OperationDashboard;